module.exports = __webpack_public_path__ + "media/assets/social-fb-b8a372329cbd63a0c9b5df476c3dd209.png";